import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/sif/drob/temperament";

export const fetchTemperamentScores = createAsyncThunk(
  "temperamentScore/list",
  async (_, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(baseUrl);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const temperamentScoreSlice = createSlice({
  name: "temperamentScore",
  initialState: {
    temperamenti: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTemperamentScores.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchTemperamentScores.fulfilled, (state, action) => {
        state.isLoading = false;
        state.temperamenti = action.payload;
      })
      .addCase(fetchTemperamentScores.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default temperamentScoreSlice.reducer;
